module.exports = __webpack_public_path__ + "img/mtficon.e4224099.svg";